import React, { useState, useRef, useEffect, useCallback } from "react"
import { Button, Image, Modal, Spin } from "antd"
import logoIter from "assets/images/logo_iter.jpg"
import logoGenexisMx from "assets/images/Genexis_mx_logo.jpg"
import { PrinterOutlined } from "@ant-design/icons"
import { getBase64, objetoVacio } from "util/utils"
import LoaderComponent from "components/LoaderTerpel/LoaderTerpel"
import ".././estilos/ticketcss/IterReceipt.css"
import { formatearFecha, formato12Horas, formatosFecha } from '../../../../../util/formatDate';
import { setearMiles } from "util/funciones"
// import { setearM, setearMilesiles } from "util/funciones"


interface IterReceiptProps {
  tickets: Array<{
    medios_pago: {
      descripcion: string;
      valor_recibido: number;
      valor_total: number;
      valor_cambio: number;
    }[];
    recaudos_detallado: {
      descripcion: string;
      valor_concepto: number;
      monto: number;
    }[];
    cliente: {
      nombres: string;
      identificacion: string;
      placa: string;
    };
    recaudo: {
      cantidad: number;
      valor: number;
    };
    empresa: {
      nit: string;
      alias: string;
      razon_social: string;
      direccion: string;
      telefono: string;
      correo: string;
    }
    numero_ticket: number;
    fecha: string;
    fecha_generacion: string;
    fecha_fin_despacho: string;
    footer_ticket: string;
    valor_texto: string;
    promotor: string;
    jornada: number;
    producto: string;
    precio: number;
    cara: number;
    surtidor: number;
    manguera: number;
    isla: number;
    cantidad: number;
    venta_total: number;
    tipo_autorizacion: string;
    pos: string;
    serial: string;
    turno_descripcion: string;
  }>;

  getTickes: () => void;
  isLoading: boolean;
  disabled: boolean;

  ticketLimit: boolean;
  numberOfTicketIds: number;

  logoTicket: string
}

export default function SalesReportReceipt({ tickets, getTickes, isLoading, disabled, ticketLimit, numberOfTicketIds, logoTicket }: IterReceiptProps) {
  console.log("🚀 ~ SalesReportReceipt ~ logoTicket:", logoTicket)
  const [isPreviewVisible, setIsPreviewVisible] = useState(false)
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const receiptRefs = useRef<HTMLDivElement[]>([])
  const [isPrinting, setIsPrinting] = useState(false)
  const receiptRef = useRef<HTMLDivElement>(null)
  const [logoBase, setLogoBase] = useState(logoTicket)
  const imageRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const loadImage = async () => {
      try {
        // const base64 = await getBase64(logoGenexisMx)
        setLogoBase(logoTicket)
        setIsImageLoaded(true)
      } catch (error) {
        console.error("Error loading image:", error)
        setLogoBase("/placeholder.svg")
        setIsImageLoaded(true)
      }
    }
    loadImage()
  }, [])

  const handlePreview = () => {
    if (ticketLimit) {
      setIsConfirmVisible(true); // Muestra el modal de confirmación si hay más de 10 tickets
    } else {
      setIsPreviewVisible(true); // Si hay 10 o menos, muestra la vista previa directamente
      getTickes();
    }
  };

  const handleConfirmOk = () => {
    setIsConfirmVisible(false);
    setIsPreviewVisible(true); // Muestra la vista previa si el usuario acepta
    getTickes();
  };

  const handleConfirmCancel = () => {
    setIsConfirmVisible(false); // Cierra el modal si el usuario cancela
  };


  const handlePrint = useCallback(() => {
    if (!isImageLoaded) {
      console.error("Image not loaded yet")
      return
    }

    setIsPrinting(true)

    // Create an iframe to handle silent printing
    const iframe = document.createElement("iframe")
    iframe.style.display = "none"
    document.body.appendChild(iframe)

    // Get the receipt content
    const receiptsHtml = tickets
      .map((_, index) => {
        const receiptHtml = receiptRefs.current[index]?.outerHTML || "";
        return receiptHtml.replace(`src="${logoTicket}"`, `src="${logoTicket}"`);
      })
      .join('<div class="receipt__separator"></div>');

    // Write the content to the iframe
    const iframeDoc = iframe.contentWindow?.document

    const styles = `
    <style>
      @media print {
        /* General Styles */
        body {
        margin: 0;
        padding: 0;
        font-family: "Consolas", "Liberation Mono", "Menlo", monospace;
        font-weight: 400;
        font-stretch: condensed;
        -webkit-font-stretch: condensed;
        font-variant-numeric: tabular-nums;

        }
        .receipt {
          width: 80mm;
          page-break-before: always;
          background-color: white;
          font-family: "Consolas", "Liberation Mono", "Menlo", monospace;
          font-size: 12px;
          padding-bottom: 2rem;
          margin-bottom: 2rem;
          letter-spacing: 0px;
          font-weight: 400;
          font-stretch: condensed;
          -webkit-font-stretch: condensed;
          font-variant-numeric: tabular-nums;
        }

        .receipt:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .receipt p {
          margin: 0;
          padding: 0;
          line-height: 2;
          /* Ajusta el espaciado entre líneas según sea necesario */
        }

        .receipt__preview-container {
          padding: 1.8rem;
          background-color: #f0f0f0;
          border-radius: 8px;
        }

        .receipt table {
          width: 100%;
        }

        .receipt__text--center {
          text-align: center;
          width: 100%;
        }

        /* Separators */
        .receipt__separator {
          border-top: 1px dashed #000;
          height: 1px;
        }

        .receipt__table td,
        .receipt__table th {
          font-size: 12px;
          font-weight: 400;
          font-stretch: condensed;
        }

        .receipt__table td {
          width: 50%;
        }

        .receipt__table tr {
          width: 100%;
          display: flex;
        }

        .receipt__table-cell,
        .receipt__table-header {
          text-align: left;
          vertical-align: middle;
        }

        /* .receipt__table-cell {
          padding: 1mm 0;
        } */

        .mt-2 {
          margin-top: 20px
        }

        .text-center {
          text-align: center !important;
        }
        @page {
          margin: 0;
          size: 80mm 297mm;
        }
        
        .text__ellipsis {
          width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-family: "Consolas", "Liberation Mono", "Menlo", monospace !important;
        }
      }
    </style>
  `;
    if (iframeDoc) {
      iframeDoc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            ${styles}
          </head>
          <body>
            ${receiptsHtml.replace(`src="${logoTicket}"`, `src="${logoTicket}"`)}
          </body>
        </html>
      `)
      iframeDoc.close()

      // Wait for images to load
      try {
        // Access the iframe's window object
        const iframeWindow = iframe.contentWindow
        if (iframeWindow) {
          // Set up beforeprint and afterprint listeners
          iframeWindow.addEventListener("beforeprint", () => {
            setIsPrinting(true)
          })

          iframeWindow.addEventListener("afterprint", () => {
            setIsPrinting(false)
            setIsPreviewVisible(false)
            document.body.removeChild(iframe)
          })

          // Print without showing dialog
          iframeWindow.focus()
          iframeWindow.print()
        }
      } catch (error) {
        console.error("Print error:", error)
        document.body.removeChild(iframe)
        setIsPrinting(false)
      }
    }
  }, [isImageLoaded, logoBase, tickets])

  useEffect(() => {
    if (imageRef.current && logoBase) {
      imageRef.current.src = logoTicket
    }
  }, [logoBase])


  return (
    <div className="flex flex-col items-center gap-2 m-auto">
      <Button disabled={disabled} icon={<PrinterOutlined style={{ height: '5rem' }} />} onClick={handlePreview} className="min-w-[80mm]">
        Generar Ticket(s)
      </Button>
      {/* Modal de Confirmación */}
      {isConfirmVisible && < Modal
        visible={isConfirmVisible}
        onOk={handleConfirmOk}
        onCancel={handleConfirmCancel}
        title="Confirmación"
        okText="Aceptar"
        cancelText="Cancelar"
      >
        <p>Se han seleccionado más de 10 registros. <strong>({numberOfTicketIds})</strong> ¿Deseas imprimirlos?</p>
      </Modal>}

      {
        (isPreviewVisible) && (
          <Modal
            visible={isPreviewVisible}
            onCancel={() => !isPrinting && setIsPreviewVisible(false)}
            footer={null}
            title="Vista Previa"
            width={450}
            className="overflow-auto"
            maskClosable={!isPrinting}
            closable={!isPrinting}
          >
            <div className="flex flex-col p-2 m-2 gap-2">
              <div
                className="receipt__preview-container"
                style={{
                  minHeight: "400px",
                  maxHeight: "65vh",
                  overflowY: "auto",
                }}
              >
                {isLoading ? <LoaderComponent text="generando tickets..." /> : tickets.map((ticket, index) => (
                  <div
                    key={index}
                    ref={(el) => (receiptRefs.current[index] = el as HTMLDivElement)}
                    className="receipt"
                  >
                    <div className="receipt__text--center">
                      <img
                        ref={imageRef}
                        src={logoTicket || "/placeholder.svg"}
                        alt="Logo"
                        style={{ height: "7rem", marginBottom: "18px" }}
                        onLoad={() => setIsImageLoaded(true)}
                        onError={() => {
                          console.error("Error loading image")
                          setLogoBase("/placeholder.svg")
                          setIsImageLoaded(true)
                        }}
                      />
                      <p>{ticket.empresa.razon_social}</p>
                      <p>{ticket.empresa.alias}</p>
                      <p>{ticket.empresa.direccion}</p>
                      <p>TEL: {ticket.empresa.telefono}</p>
                      <p>{ticket.empresa.correo}</p>
                      <p>RFC: {ticket.empresa.nit}</p>
                    </div>

                    <div className="receipt__separator"></div>
                    <div className="receipt__separator"></div>
                    <table className="receipt__table">
                      <tbody>
                        <tr>
                          <td>ORIGEN:</td>
                          <td>REPORTE WEB</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="receipt__separator"></div>
                    <div className="receipt__separator"></div>

                    <table className="receipt__table">
                      <tbody>
                        <tr>
                          <td>NRO DE TICKET:</td>
                          <td>{ticket.numero_ticket}</td>
                        </tr>
                        <tr>
                          <td>TIPO AUTORIZACION:</td>
                          <td>{ticket.tipo_autorizacion}</td>
                        </tr>
                        <tr>
                          <td>FECHA IMPRESION:</td>
                          <td>{formatearFecha(new Date(), formatosFecha.completa2)}</td>
                        </tr>
                        <tr>
                          <td>INICIO DESPACHO:</td>
                          <td>{formatearFecha(ticket.fecha_generacion, formatosFecha.completa2)}</td>
                        </tr>
                        {ticket.fecha_fin_despacho && (
                          <tr>
                            <td>FIN DESPACHO:</td>
                            <td>{formatearFecha(ticket.fecha_fin_despacho, formatosFecha.completa2)}</td>
                          </tr>
                        )}
                        <tr>
                          <td>TURNO:</td>
                          <td>{ticket.jornada}</td>
                        </tr>
                        {ticket.turno_descripcion && (
                          <tr style={{ overflow: 'hidden' }}>
                            <td>TURNO DESC:</td>
                            <td><p className="text__ellipsis">{ticket.turno_descripcion}</p></td>
                          </tr>
                        )}
                        <tr>
                          <td>PROMOTOR:</td>
                          <td>{ticket.promotor}</td>
                        </tr>
                      </tbody>
                    </table>

                    <table className="receipt__table">
                      <tbody>
                        <tr>
                          <td>POS:</td>
                          <td>ISLA:</td>
                          <td>SURTIDOR:</td>
                          <td>CARA:</td>
                          <td>MANGUERA:</td>
                        </tr>
                        <tr>
                          <td>{ticket.pos}</td>
                          <td>{ticket.isla}</td>
                          <td>{ticket.surtidor}</td>
                          <td>{ticket.cara}</td>
                          <td>{ticket.manguera}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="receipt__separator"></div>
                    <div className="receipt__separator"></div>

                    <table className="receipt__table">
                      <tbody>
                        <tr>
                          <td>CLIENTE:</td>
                          <td>{ticket.cliente.nombres}</td>
                        </tr>
                        <tr>
                          <td>IDENTIFICACION:</td>
                          <td>{ticket.cliente.identificacion}</td>
                        </tr>
                        <tr>
                          <td>PLACA:</td>
                          <td>{ticket.cliente.placa}</td>
                        </tr>
                        <tr>
                          <td>SERIAL:</td>
                          <td>{ticket.serial}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="receipt__separator"></div>
                    <div className="receipt__separator"></div>

                    <table className="receipt__table">
                      <thead>
                        <tr>
                          <th className="receipt__table-header">PRODUCTO</th>
                          <th className="receipt__table-header">PRECIO</th>
                          <th className="receipt__table-header">CANTIDAD</th>
                          <th className="receipt__table-header">TOTAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="receipt__table-cell">{ticket.producto}</td>
                          <td className="receipt__table-cell">${setearMiles(Number(ticket.precio))}</td>
                          <td className="receipt__table-cell">{ticket.cantidad} LT</td>
                          <td className="receipt__table-cell">${setearMiles(Number(ticket.venta_total))}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="receipt__separator"></div>
                    <div className="receipt__separator"></div>

                    <div className="text-center">DETALLES MEDIOS DE PAGO</div>

                    <table className="receipt__table">
                      <thead>
                        <tr>
                          <th className="receipt__table-header">MEDIO DE PAGO</th>
                          <th className="receipt__table-header">TOTAL M. PAGO</th>
                          <th className="receipt__table-header">RECIBIDO</th>
                          <th className="receipt__table-header">CAMBIO</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ticket.medios_pago.map((mPago, i) => (
                          <tr key={i}>
                            <td className="receipt__table-cell">{mPago.descripcion}</td>
                            <td className="receipt__table-cell">${setearMiles(Number(mPago.valor_total))}</td>
                            <td className="receipt__table-cell">${setearMiles(Number(mPago.valor_recibido))}</td>
                            <td className="receipt__table-cell">${setearMiles(Number(mPago.valor_cambio))}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <div className="receipt__separator"></div>
                    <div className="receipt__separator"></div>

                    {
                      !objetoVacio(ticket.recaudo) ? (<>
                        <div className="text-center">RECAUDO</div>

                        <table className="receipt__table">
                          <thead>
                            <tr>
                              <th className="receipt__table-header">TOTAL RECAUDO X LT</th>
                              <th className="receipt__table-header">TOTAL RECAUDO</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="receipt__table-cell">{ticket.recaudo.cantidad}</td>
                              <td className="receipt__table-cell">${setearMiles(Number(ticket.recaudo.valor))}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div className="receipt__separator"></div>
                        <div className="receipt__separator"></div>

                        <div className="text-center">RECAUDO DETALLADO</div>

                        <table className="receipt__table">
                          <thead>
                            <tr>
                              <th className="receipt__table-header">CONCEPTO</th>
                              <th className="receipt__table-header">VALOR</th>
                              <th className="receipt__table-header">MONTO</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ticket.recaudos_detallado.map((detalle, i) => (
                              <tr key={i}>
                                <td>{detalle.descripcion}</td>
                                <td>{detalle.valor_concepto}</td>
                                <td>${detalle.monto}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div className="receipt__separator"></div>
                        <div className="receipt__separator"></div>

                      </>) : <></>
                    }

                    <table className="receipt__table">
                      <tbody>
                        <tr>
                          <td className="receipt__table-cell">TOTAL:</td>
                          <td className="receipt__table-cell">${setearMiles(Number(ticket.venta_total))}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="">
                      {ticket.valor_texto}
                    </div>

                    <div className="receipt__separator"></div>


                    <div className="text-center text-xs mt-2">
                      {ticket.footer_ticket}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col items-center justify-center">

              <Button onClick={handlePrint} className="mx-auto" disabled={isLoading || isPrinting} loading={isPrinting}>
                {isPrinting ? "Imprimiendo..." : "Imprimir"}
              </Button>
            </div>
          </Modal>
        )
      }
    </div >
  )
}
